var _config = {
    siteCulture: "nl-NL",
    selectedCountry: "NL",
    countries: [
        { Code:"NL", Name: "Nederland"},
        { Code:"BE", Name: "Belgie"},
        { Code:"DE", Name: "Duitsland"},
    ],
    PaymentMethods: [ 
        { 
            Name:"IDEAL", 
            Title: "Ideal", 
            Logo: "/images/logo-ideal.png",
            Id: "radioIdeal",
            AllCountries: true,
            AllShippingCountries: true,
            Note: "Meest gekozen",
            NoteColor: "text-success",
            Cost: "Gratis",
            SelectIssuerHeader:"Selecteer jouw bank",
            Issuers: [
                {
                    Name: "IDEAL:0721",
                    Title: "ING Bank",
                    Id: "ing",
                    Logo: "/images/Logo-Ing.jpg"
                },
                {
                    Name: "IDEAL:0031",
                    Title: "ABN AMRO Bank",
                    Id: "abn",
                    Logo: "/images/Logo-Abn.jpg"          
                },
                {
                    Name: "IDEAL:0021",
                    Title: "Rabobank",
                    Id: "rabo",
                    Logo: "/images/Logo-Rabo.jpg"          
                },
                {
                    Name: "IDEAL:0761",
                    Title: "ASN bank",
                    Logo: "/images/Logo-Asn.jpg"          
                },
                {
                    Name: "IDEAL:0751",
                    Title: "SNS Bank",
                    Id: "sns",
                    Logo: "/images/Logo-SnsBank.jpg"          
                },
                {
                    Name: "IDEAL:0771",
                    Title: "RegioBank",
                    Logo: "/images/Logo-RegioBank.jpg"          
                },
                {
                    Name: "IDEAL:0161",
                    Title: "VanLanschot Bankiers",
                    Id: "van-lanschot",
                    Logo: "/images/Logo-VanLanschot.jpg"          
                },
                {
                    Name: "IDEAL:0511",
                    Title: "Triodos Bank",
                    Id: "triodos",
                    Logo: "/images/Logo-Triodos.jpg"          
                },
                {
                    Name: "IDEAL:0801",
                    Title: "KNAB Bank",
                    Id: "knab",
                    Logo: "/images/Logo-Knab.jpg"          
                },
                {
                    Name: "IDEAL:4371",
                    Title: "bunq",
                    Id: "knab",
                    Logo: "/images/Logo-bunq.jpg"          
                },
                {
                    Name: "IDEAL:1099",
                    Title: "Revolut",
                    Id: "Revolut",
                    Logo: "/images/Logo-revolut.jpg"          
                }
            ]
        },
        { 
            Name: "GOOGLEPAY", 
            Title: "GooglePay", 
            Logo: "/images/logo-googlepay.png",
            Id: "radioGooglepay",
            Note: "",
            NoteColor: "text-muted",
            Cost: "Gratis",
            AllCountries: false,
            Countries: ["NL","BE"],
            AllShippingCountries: false,
            ShippingCountries: ["NL","BE"],
            Issuers: []
        },
        { 
            Name: "APPLEPAY", 
            Title: "ApplePay", 
            Logo: "/images/logo-applepay.svg",
            Id: "radioApplepay",
            Note: "",
            NoteColor: "text-muted",
            Cost: "Gratis",
            AllCountries: false,
            Countries: ["NL","BE"],
            AllShippingCountries: false,
            ShippingCountries: ["NL","BE"],
            Issuers: []
        },
        { 
            Name: "AFTERPAY", 
            Title: "Riverty", 
            Logo: "/images/logo-riverty.png",
            Id: "radioRiverty",
            Note: "Betaal na ontvangst",
            NoteColor: "text-muted",
            Cost: "Gratis",
            AllCountries: false,
            Countries: ["NL","BE"],
            AllShippingCountries: false,
            ShippingCountries: ["NL","BE"],
            Issuers: []
        },
        { 
            Name: "PayPal", 
            Title: "PayPal", 
            Logo: "/images/logo-paypal.png",
            Id: "radioPayPal",
            Note: "",
            Cost: "Gratis",
            AllCountries: true,
            AllShippingCountries: true,
            Issuers: []
        },
        { 
            Name: "Visa", 
            Title: "Visa", 
            Logo: "/images/Checkout-Visa.png",
            Id: "radioVisa",
            Note: "",
            Cost: "Gratis",
            AllCountries: true,
            AllShippingCountries: true,
            Issuers: []
        },
        { 
            Name: "Mastercard", 
            Title: "Mastercard", 
            Logo: "/images/logo-mastercard.png",
            Id: "radioMastercard",
            Note: "",
            Cost: "Gratis",
            AllCountries: true,
            AllShippingCountries: true,
            Issuers: []
        },
        { 
            Name: "Maestro", 
            Title: "Maestro", 
            Logo: "/images/logo-maestro.png",
            Id: "radioMaestro",
            Note: "",
            Cost: "Gratis",
            AllCountries: true,
            AllShippingCountries: true,
            Issuers: []
        },
        { 
            Name: "Mistercash", 
            Title: "Mistercash", 
            Logo: "/images/logo-bancontact.png",
            Id: "radioMistercash",
            Note: "",
            Cost: "Gratis",
            AllCountries: false,
            Countries: ["BE"],
            AllShippingCountries: true,
            Issuers: []
        },
        { 
            Name: "BankTrans", 
            Title: "Bank Transfer", 
            Logo: "/images/logo-banktrans.png",
            Id: "radioBankTransfer",
            Note: "Minimaal 2 dagen vertraging in verwerking",
            NoteColor: "text-muted",
            Cost: "Gratis",
            AllCountries: true,
            AllShippingCountries: true,
            Issuers: []
        },
        { 
            Name: "Sofort", 
            Title: "Sofort", 
            Logo: "/images/logo-sofort.png",
            Id: "radioSofort",
            Note: "",
            Cost: "Gratis",
            AllCountries: false,
            Countries: ["DE"],
            AllShippingCountries: true,
            Issuers: []
        },
        { 
            Name: "GiroPay", 
            Title: "GiroPay", 
            Logo: "/images/logo-giropay.png",
            Id: "radioGiroPay",
            Note: "",
            Cost: "Gratis",
            AllCountries: false,
            Countries: ["DE"],
            AllShippingCountries: true,
            Issuers: []
        },
        { 
            Name: "Belfius", 
            Title: "Belfius", 
            Logo: "/images/logo-belfius.png",
            Id: "radioBelfius",
            Note: "",
            Cost: "Gratis",
            AllCountries: false,
            Countries: ["BE"],
            AllShippingCountries: true,
            Issuers: []
        },
        { 
            Name: "KBC", 
            Title: "KBC", 
            Logo: "/images/logo-kbc.png",
            Id: "radioKBC",
            Note: "",
            Cost: "Gratis",
            AllCountries: false,
            Countries: ["BE"],
            AllShippingCountries: true,
            Issuers: []
        },
    ]
}